import { ADFAction, ADFState, CompanyAction, UserActions } from "../stores/user/user-state";
import CONSTANTS from "./constants";

/**
 * selectCurrentADF can be used to find the first incomplete ADF for a given user
 * @param userActions the userActions returned from the bff/user-info request
 * @param adfId not currently used yet, but may be used in the future when the user is
 * given the ability to select a specific ADF.
 * @returns The ADFState used by Sync Your Accounting
 */
export const selectCurrentADF = (userActions: UserActions, adfId?: string): ADFState => {
    const company = userActions?.companies?.find(hasIncompleteADF)
    const currentADF = firstIncompleteADF(company?.adfs)
    return currentADF ? {
        adf_id: currentADF.adf_id,
        codat_company_id: currentADF.codat_company_id,
        fiscal_year_end_dt: currentADF.fiscal_year_end_date,
        legal_entity_name: company.legal_entity_name,
        dba_name: company.dba_name,
        status: currentADF.status,
        product: currentADF.product
    } : null
}

function hasIncompleteADF(company: CompanyAction): boolean {
    return company?.adfs?.some((adf) => !adf?.status?.startsWith("Complete"))
}

function firstIncompleteADF(adfActions: ADFAction[]): ADFAction {
    return adfActions?.find(adf => !adf.status.startsWith("Complete"))
}